
import { Component, Vue, Prop } from 'vue-property-decorator'
import { PersonService } from '@/services/index'

@Component({
    name: 'company-table'
})
export default class CompanyTable extends Vue {
    @Prop({ required: true }) private value!: any[]

    private statusOptions = [
        { key: 1, value: '已审核' }, 
        { key: 2, value: '未审核' }, 
        { key: 3, value: '未通过' }
    ]

    private async updateStatus(params: any) {
        const result = await PersonService.updatePersonInfo(params)
        if (result.status === 200) {
            this.$message({ type: 'success', message: '设置成功' })
            return { status: true }
        }
        return {
            status: false,
            message: result.message
        }
    }

    private async onStatusSelect(status: any, item: any) {
        this.$set(item, 'loading', true)
        const { id: personId } = item
        const params = { id: personId, check: status }
        const result = await this.updateStatus(params)
        item.loading = false
        if (result.status) {
            item.check = status
        } else {
            item.check = ''
        }
    }
}
